import React from 'react';
import { Container, Card, Button, Image } from 'react-bootstrap';
import { FaHeart, FaFacebook, FaTiktok, FaInstagram } from 'react-icons/fa';


function AboutUs() {
  return (
    <div

    >
      <Container className="d-flex justify-content-center">
        <Card className="shadow-sm" style={{ maxWidth: '800px', borderRadius: '15px' }}>
          <Card.Header
            className="text-center"
            style={{
              backgroundColor: 'rgba(255, 255, 255, 0.7)',
              borderBottom: 'none',
              padding: '30px',
            }}
          >
            <img
              src="/cakerylogo.png"
              alt="Cakery Logo"
              style={{ width: '100px', height: 'auto'}}
            />
            <h2 style={{ color: '#FEA2C2'}}>About Us</h2>
          </Card.Header>
          <Card.Body >

            <h3 >
            We Are Turning{" "}
            <span className="gradient-text"> Sweet Dreams </span> Into Reality
          </h3>

            <p style={{ color: '#666666', fontSize: '18px', lineHeight: '1.6' }}>
            Cakery makes it easy to find and customize the perfect cake while supporting local bakeries and home bakers.
            </p>
            <p style={{ color: '#666666', fontSize: '18px', lineHeight: '1.6' }}>
            Our founder, a passionate baker, wanted to simplify the process of designing and ordering custom cakes. What was once a tedious task is now effortless — connect with local bakers, customize your dream cake, and make your celebrations even more special.

            </p>
            <p style={{ color: '#666666', fontSize: '18px', lineHeight: '1.6' }}>
            Cakery was created to bring your sweetest ideas to life, one cake at a time.
            </p>

            {/* Team Image Section */}
            <div className="text-center my-4">
              <h5 style={{ color: '#FEA2C2', marginBottom: '15px' }}>Meet the Cakery Team</h5>
              <Image
                src="/CakeryTeam.png"
                alt="Cakery Team"
                fluid
                rounded
                style={{
                  maxWidth: '100%',
                  height: 'auto',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                  marginBottom: '20px',
                }}
              />
              <p style={{ color: '#666666', fontSize: '16px', lineHeight: '1.6' }}>
                A dedicated team of talented developers and designers who are 
                <br></br>
                striving to transform the cake ordering process!
              </p>
            </div>

           {/* Button Row Section */}
            <div className="d-flex justify-content-between align-items-center mt-4 px-3">
              {/* Back to Home Button */}
              <Button
                href="/"
                style={{
                  backgroundColor: '#FFD9E4',
                  borderColor: '#FFD9E4',
                  color: 'black',
                  fontWeight: 'bold',
                  fontSize: '16px',
                  padding: '12px 28px',
                  borderRadius: '30px',
                  minWidth: '160px',
                }}
              >
                ← Back to Home
              </Button>

              {/* Get in Touch Button */}
              <Button
                href="/contact-us"
                style={{
                  backgroundColor: '#FEA2C2',
                  borderColor: '#FEA2C2',
                  color: 'white',
                  fontWeight: 'bold',
                  fontSize: '16px',
                  padding: '12px 28px',
                  borderRadius: '30px',
                  minWidth: '160px',
                  boxShadow: '0 4px 12px rgba(254, 162, 194, 0.5)',
                }}
              >
                Get in Touch
              </Button>
            </div>


           
          </Card.Body>
        </Card>
      </Container>

      <Container className="text-center py-5">
      <h3 className="mb-3" style={{ color: "#FEA2C2" }}>Follow Us on Social Media</h3>
      <p className="text-muted">Stay updated with our latest cakes and promotions!</p>
      
      <div className="d-flex justify-content-center gap-4">
        {/* Facebook */}
        <a href="https://www.facebook.com/share/14h5nG1G5J/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="social-icon">
          <FaFacebook size={40} className="text-primary" />
        </a>

        {/* TikTok */}
        <a href="https://www.tiktok.com/@cakeryhq?_t=ZT-8ukWwuQLAIo&_r=1" target="_blank" rel="noopener noreferrer" className="social-icon">
          <FaTiktok size={40} className="text-dark" />
        </a>

        {/* Instagram */}
        <a href="https://www.instagram.com/cakeryhq?igsh=NHRqdHJvYTR4d28x&utm_source=qr" target="_blank" rel="noopener noreferrer" className="social-icon">
          <FaInstagram size={40} className="text-danger" />
        </a>
      </div>
    </Container>
    </div>
  );
}

export default AboutUs;
